"use client";

import { useState, useRef, useEffect } from "react";
import { X } from "lucide-react";
import { Icons } from "../assets/icons/Icons";

const ProfilePictureModal = ({
    show,
    onClose,
    name = "Alexandra Alexa",
    profileImage = "https://hebbkx1anhila5yf.public.blob.vercel-storage.com/Account-2ETemGCgxU3qokcpHzK5BCXCGnhXZd.png",
    onSave,
}) => {
    const divRef = useRef(null);
    const [image, setImage] = useState(profileImage);
    const [newImage, setNewImage] = useState(null);
    const fileInputRef = useRef(null);

    useEffect(() => {
        const preventScroll = (event) => {
            event.preventDefault();
        };

        const div = divRef.current;
        if (div) {
            div.addEventListener("wheel", preventScroll, { passive: false });
        }

        return () => {
            if (div) {
                div.removeEventListener("wheel", preventScroll);
            }
        };
    }, []);

    const handleFileChange = (e) => {
        if (e.target.files && e.target.files[0]) {
            const file = e.target.files[0];
            const reader = new FileReader();

            reader.onload = (event) => {
                setImage(event.target.result);
                setNewImage(file);
            };

            reader.readAsDataURL(file);
        }
    };

    const handleChangeClick = () => {
        fileInputRef.current.click();
    };

    const handleSave = () => {
        if (onSave) {
            onSave(newImage || image);
        }
        onClose();
    };

    if (!show) return null;

    return (
        <div
            ref={divRef}
            className="offcanvas offcanvas-top rounded-m"
            id="menu-notifications"
            style={{
                height: "100vh",
                backgroundImage: "url('./images/store/notification_bg.png')",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "0px 0px",
                backgroundSize: "contain",
                backgroundColor: "#000000",
            }}
        >
            <div
                className="d-flex flex-column align-items-center"
                style={{
                    width: "100%",
                    maxWidth: "400px",
                    marginTop: 20,
                }}
            >
                <a
                    href="#"
                    className="shadow-0 position-absolute top-0 end-0 m-3 mt-5"
                    data-bs-dismiss="offcanvas"
                >
                    <Icons.CloseWithBG />
                </a>

                {/* Profile Picture */}
                <div
                    className="d-flex justify-content-center align-items-center mb-3"
                    style={{ marginTop: "100px" }}
                >
                    <div
                        className="rounded-circle overflow-hidden"
                        style={{
                            width: "150px",
                            height: "150px",
                            border: "4px solid white",
                        }}
                    >
                        <img
                            src={image || "/placeholder.svg"}
                            alt={name}
                            className="w-100 h-100"
                            style={{ objectFit: "cover" }}
                        />
                    </div>
                </div>

                {/* Name */}
                <h2 className="text-white fs-2 fw-bold mb-5">{name}</h2>

                {/* Hidden File Input */}
                <input
                    type="file"
                    ref={fileInputRef}
                    onChange={handleFileChange}
                    accept="image/*"
                    className="d-none"
                />

                {/* Change Profile Picture Button */}
                <button
                    className="btn w-75 mb-3 py-3"
                    onClick={handleChangeClick}
                    style={{
                        backgroundColor: "#1E1E1E",
                        color: "white",
                        borderRadius: "12px",
                        fontSize: "18px",
                    }}
                >
                    Change Profile Picture
                </button>

                {/* Save Button */}
                <button
                    className="btn w-75 mb-auto py-3"
                    onClick={handleSave}
                    style={{
                        backgroundColor: "#2E2CB2",
                        color: "white",
                        borderRadius: "12px",
                        fontSize: "18px",
                    }}
                >
                    Save
                </button>
            </div>
        </div>
    );
};

export default ProfilePictureModal;
